export const CopyIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='13'
    height='14'
    viewBox='0 0 13 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 0H1C0.447715 0 0 0.447715 0 1V11H2V2H10V0ZM4 3C3.44772 3 3 3.44772 3 4V13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13V4C13 3.44772 12.5523 3 12 3H4ZM11 12H5V5H11V12Z'
      fill='#94A3B8'
    />
  </svg>
);
